
<modal :state="state" :index="index" @toggle-modal="cancel" class="md fds">

  <div slot="body">
    <h3 class="modal-title">Configure Process</h3>
    <p class="modal-subheading mb-3 pb-1">Map data to Variables</p>
    <div class="container mb-0">
      <row>
        <label class="label-lg text-color-secondary">Map Request</label>
      </row>
    </div>
    <div class="container mb-4">
      <template v-for="variable in variableOptionsFor">
          <row component-row class="align-left mb-3">
            <column size="50%-40">
              <a-select :id="variable.id"
                        :options="objectModelOptions"
                        v-model="mappedVariableFor(variable).source_id"
              ></a-select>
            </column>

            <column size="75" class="d-flex justify-content-center">
              <div class="toggle-arrow checked disabled">
                <input type="checkbox" disabled="disabled" value="Push">
              </div>
            </column>

            <column size="50%-35">
              <div>
                <h4 class="p" :class="isRequired(variable)"><strong>{{variable.name}} <required-indicator v-if="variable.is_input_required" /></strong></h4>
              </div>
            </column>
          </row>
      </template>
    </div>
    <div class="row pt-2 modal-btn-group">
      <div class="col">
        <div class="cta d-flex justify-content-end">
          <button @click="cancel" class="btn block red outline">Cancel</button>
        </div>
      </div>
      <div class="col">
        <div class="cta d-flex justify-content-start">
          <button @click="save" class="btn block green">Save</button>
        </div>
      </div>
    </div>
  </div>
</modal>
